import type { ReactNode } from 'react';
import { cn } from '../../utils/helpers';

interface CardProps {
  children: ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  hover?: boolean;
  accent?: 'blue' | 'green' | 'red' | 'amber' | 'purple' | 'none';
}

export function Card({ children, className, padding = 'md', hover = false, accent = 'none' }: CardProps) {
  const paddings = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  };

  const accentClass = accent !== 'none'
    ? `stat-card-accent accent-${accent}`
    : '';

  return (
    <div
      className={cn(
        'bg-[#141420] border border-[#252535] rounded-2xl',
        paddings[padding],
        hover && 'card-hover cursor-pointer',
        accentClass,
        className
      )}
    >
      {children}
    </div>
  );
}

interface CardHeaderProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
}

export function CardHeader({ title, subtitle, action }: CardHeaderProps) {
  return (
    <div className="flex items-start justify-between mb-5">
      <div>
        <h3 className="text-base font-semibold text-[#f1f5f9]">{title}</h3>
        {subtitle && <p className="text-sm text-[#64748b] mt-0.5">{subtitle}</p>}
      </div>
      {action && <div>{action}</div>}
    </div>
  );
}
